import { ageRatingBoard } from 'Helpers/Geo/data';

/**
 * Custom hook to determine if age gating is required
 * @param {boolean} passedAgeGate - Whether user has passed age gate
 * @param {Object} ageRatings - Age ratings object
 * @param {string} dateOfBirth - User's date of birth
 * @returns {boolean} Whether age gating is required
 */
const useAgeGateRequired = (passedAgeGate, ageRatings, dateOfBirth) => {
  const ageGateThresholds = {
    ESRB: 17,
    USK: 16,
    PEGI: 18,
    ACB: 18,
  };

  let ageGateRequired = false;
  if (!passedAgeGate && ageRatings[ageRatingBoard] >= ageGateThresholds[ageRatingBoard]) {
    ageGateRequired = true;
  }

  if (dateOfBirth && dateOfBirth !== '') {
    const dobDate = new Date(dateOfBirth);
    const year = dobDate.getFullYear();
    const month = dobDate.getMonth() + 1;
    const day = dobDate.getDate();

    if (year && month && day) {
      const today = Date.now();
      const userDate = new Date(year, month, day);
      const ageDifference = (today - userDate) / 1000 / 60 / 60 / 24 / 363.5;

      if (ageDifference >= (ageRatings[ageRatingBoard])) {
        ageGateRequired = false;
      }
    }
  }

  return ageGateRequired;
};

export default useAgeGateRequired;
